<template>
<div>
  <v-form @submit.prevent="$v.$invalid ? () => {} : submit()" ref="form">
      <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
        <span>{{message}}</span>
      </v-snackbar>
      <v-card class="neu-glow mt-n2 pb-3">
        <v-card-title primary-title>
          <div class="text-h5">Parametri Default</div>
          <v-spacer></v-spacer>
          <v-div class="mr-n5">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update" :disabled="activeSlots_hash==JSON.stringify(activeSlots)" @click.stop="saveItems()">
                  <v-icon color="error">mdi-content-save</v-icon>
                </v-btn>
              </template>
              <span>Salva</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_instruction=true">
                  <v-icon color="info">mdi-help-circle</v-icon>
                </v-btn>
              </template>
              <span>Istruzioni</span>
            </v-tooltip>                
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading" @click.stop="getData()">
                  <v-icon color="info">mdi-sync-circle</v-icon>
                </v-btn>
              </template>
              <span>Refresh</span>
            </v-tooltip>                                     
          </v-div> 
        </v-card-title>
        <v-row v-if="loading" class="pb-3 px-3">
            <v-col class="text-center">
              <v-progress-linear
                color="info"
                height="5"
                indeterminate
                striped
              ></v-progress-linear>
            </v-col>
        </v-row>
        <v-row v-else class="pl-8 pb-5"><!--
          <v-sheet elevation="8">
            <v-tabs
              class="grey lighten-1"
              v-model="locationId"
              next-icon="mdi-arrow-right-bold-box-outline"
              prev-icon="mdi-arrow-left-bold-box-outline"
              show-arrows
            >
              <v-tabs-slider color="info"></v-tabs-slider>
              <template class="my-3">
                <template v-for="(t,ti) in allLocations" >
                  <v-tab
                    :key=ti
                    :href="'#'+t.locationId"
                  >
                    {{t.text}}
                  </v-tab>
                  <v-tab-item :key=ti :id="t.locationId">
                    <v-row class="my-n2 pl-5 pb-3">
                      <v-col cols="12" class="pl-3">-->
                        <v-sheet elevation="8">
                          <v-tabs
                            class="grey lighten-3"
                            elevation="8"
                            v-model="dowId"
                            next-icon="mdi-arrow-right-bold-box-outline"
                            prev-icon="mdi-arrow-left-bold-box-outline"
                            show-arrows
                          >
                            <v-tabs-slider color="info"></v-tabs-slider>
                            <template v-for="(d,di) in dow" >
                              <v-tab
                                :key=di
                                :href="'#'+d"
                                class="font-weight-bold"
                              >
                                {{d}}
                              </v-tab>
                              <v-tab-item :key=d :id="d" class="mb-1">

                                <v-row class="my-n2 pl-5 pb-3">
                                  <v-col cols="12">
                                    <v-sheet elevation="8">
                                      <v-tabs
                                        class="grey lighten-5 pb-3"
                                        v-model="mealId"
                                        next-icon="mdi-arrow-right-bold-box-outline"
                                        prev-icon="mdi-arrow-left-bold-box-outline"
                                        show-arrows
                                      >
                                        <v-tabs-slider color="info"></v-tabs-slider>
                                        <template v-for="(m,mi) in allMeals" >
                                          <v-tab
                                            :key=mi
                                            :href="'#'+m.mealId"
                                            class="font-weight-bold mr-3"
                                           
                                          >
                                            {{m.name}} 
                                          </v-tab>
                                          <v-tab-item :key=m :id="m.mealId" class="my-3 pl-5 mr-3" >
                                              <v-row>
                                                <v-col cols="1">
                                                  Slot
                                                </v-col>
                                                <v-col v-for="(hh,hi) in headers" :key="hi">
                                                  <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                      <div v-bind="attrs" v-on="on">
                                                        {{hh.title}}
                                                      </div>
                                                    </template>
                                                    <span v-html="hh.remarks"></span>
                                                  </v-tooltip>
                                                </v-col>
                                              </v-row>
                                              <template v-for="(s,si) in activeSlots.filter(s => s.DOW==di+1&&s.mealId==m.mealId)">
                                                <v-row :key="si" class="" >
                                                  <v-col cols="1">
                                                    <v-text-field
                                                      label="Slot"
                                                      v-model="s.slotName"
                                                      name="slot"
                                                      outlined
                                                      readonly
                                                      dense
                                                      reverse
                                                      hide-details="false"
                                                    ></v-text-field>
                                                  </v-col>
                                                  <v-col>
                                                    <v-text-field
                                                      @keyup="checkCapsLock($event,'covers',$event.target.value)"
                                                      label="Coperti"
                                                      v-model="s.covers"
                                                      name="covers"
                                                      outlined
                                                      dense
                                                      reverse
                                                      hide-details="false"
                                                    ></v-text-field>
                                                  </v-col>
                                                  <v-col>
                                                    <v-text-field
                                                      label="Prenot. da 1"
                                                      v-model="s.t1"
                                                      name="tables1"
                                                      outlined
                                                      dense
                                                      reverse
                                                      hide-details="false"
                                                    ></v-text-field>
                                                  </v-col>
                                                  <v-col>
                                                    <v-text-field
                                                      label="Prenot da 2"
                                                      v-model="s.t2"
                                                      name="tables2"
                                                      outlined
                                                      dense
                                                      reverse
                                                      hide-details="false"
                                                    ></v-text-field>
                                                  </v-col>
                                                  <v-col>
                                                    <v-text-field
                                                      label="Prenot da 3"
                                                      v-model="s.t3"
                                                      name="tables3"
                                                      outlined
                                                      dense
                                                      reverse
                                                      hide-details="false"
                                                    ></v-text-field>
                                                  </v-col>                                                                                                                                    
                                                  <v-col>
                                                    <v-text-field
                                                      label="Durata"
                                                      v-model="s.duration"
                                                      name="duration"
                                                      outlined
                                                      dense
                                                      reverse
                                                      hide-details="false"
                                                    ></v-text-field>
                                                  </v-col>
                                                  <!--
                                                  <v-col>
                                                    <v-text-field
                                                      label="Blocca Precedente"
                                                      v-model="s.blockPreviousSlot"
                                                      name="blockPreviousSlot"
                                                      outlined
                                                      dense
                                                      reverse
                                                      hide-details="false"
                                                      prefix="%"
                                                    ></v-text-field>
                                                  </v-col>
                                                  <v-col>
                                                    <v-text-field
                                                      label="Blocca Successivo"
                                                      v-model="s.blockNextSlot"
                                                      name="blockNextSlot"
                                                      outlined
                                                      dense
                                                      reverse
                                                      hide-details="false"
                                                      prefix="%"
                                                    ></v-text-field>
                                                  </v-col>                                                                                                    
                                                  <v-col>
                                                    <v-text-field
                                                      label="Anticipo €"
                                                      v-model="s.prepayment"
                                                      name="prepayment"
                                                      outlined
                                                      dense
                                                      reverse
                                                      hide-details="false"
                                                      prefix="€"
                                                    ></v-text-field>
                                                  </v-col>
                                                  <v-col>
                                                    <v-text-field
                                                      label="Chiudi Direct Booking"
                                                      v-model="s.closeDB"
                                                      type="time"
                                                      name="closeDB"
                                                      outlined
                                                      dense
                                                      reverse
                                                      hide-details="false"
                                                    ></v-text-field>
                                                  </v-col>
                                                  <v-col class="d-flex justify-center">
                                                    <v-checkbox
                                                      class="mt-0 pt-2"
                                                      dense
                                                      v-model="s.FBRequest"
                                                      label=""
                                                      hide-details
                                                    ></v-checkbox>  
                                                   </v-col>
                                                   -->
                                                </v-row>
                                              </template>
                                          </v-tab-item>
                                        </template>
                                      </v-tabs>
                                    </v-sheet>
                                  </v-col>
                                </v-row>
                              </v-tab-item>
                            </template>
                          </v-tabs>
                        </v-sheet><!--
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </template>
              </template>
            </v-tabs>
          </v-sheet>-->
        </v-row>
      </v-card>
  </v-form>
  <v-dialog v-model="dialog_instruction" max-width="800">
      <v-card>
          <v-card-title class="text-h5 mb-3">
            Istruzioni
            <v-spacer></v-spacer>
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction = false">
                    <v-icon color="info">mdi-close</v-icon>
                </v-btn>
                </template>
                <span>Esci</span>
            </v-tooltip> 
          </v-card-title>
          <v-divider></v-divider>
          <v-row class="mx-5 mt-1">
              <v-col md="6" cols="12">
                  <p>
                      Per ogni <strong>Slot</strong> di <strong>Ogni Giorno</strong>, di ogni <strong>Turno</strong> e per ogni <strong>Area</strong>, è possibile impostare vari parametri:
                      <ul>
                        <li>
                          Il numero massimo di Coperti prenotabili direttamente dal Cliente
                        </li>
                        <li>
                          Il numero massimo di tavoli da 1, 2 e 3 Coperti prenotabili direttamente dal Cliente
                        </li>
                        <li>
                          La durata dello slot, ovvero per quanto tempo il cliente può impegnare il tavolo
                        </li>
                        <li>
                          La somma richiesta, per ogni coperto, per accettare la prenotazione - ad esempio capodanno - (richiede account PayPal)
                        </li>
                        <li>
                          L'orario dal quale non vengno più accettate prenotazioni per il giorno stesso, ma il sistema invita a chiamare il locale e parlare con lo staff
                        </li>
                        <li>Se inviare o meno la richiesta di rilascio Feedback</li>
                      </ul>
                  </p>
              </v-col>
              <v-col md="6" cols="12">
                <p>
                  Per velocizzare le operazioni di inserimento, 
                </p>
                <p>
                  Il pulsante 'Salva' si attiva qualora rilevi differenze rispetto ai dati memorizzati.
                </p>
                <p>
                  Dopo il salvataggio i dati vengono automaticamente ricaricati: qualora notaste delle incongruenze, prima di fare ulteriori modifiche cliccare sul tasto 'Refresh'
                </p>
              </v-col>
              <v-col cols="12">
                <p color="error--text">
                  <strong>Nota:</strong> Questi vincoli valgono solo per le prenotazioni dirette da parte dei clienti. L'operatore può accettare qualsiasi prenotazione e bypassare ogni blocco.
                </p>
              </v-col>
          </v-row>
      </v-card>
  </v-dialog>
</div>
</template>
<script>
import { mapGetters } from "vuex";
//import _ from 'lodash'
export default {
  data() {
    return {
      page: "Settings",
      loading:false,
      loading_update:false,
      dialog_instruction:false,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      allLocations:null,
      clockStep:null,
      activeSlots:null,
      activeSlots_hash:null,
      tabs:[],
      capsLockOn:false,
      dow:['LUN','MAR','MER','GIO','VEN','SAB','DOM'],
      headers:[
              {title:"Max Coperti",remarks:"Max Coperti accettabili in quello slot"},
              {title:"Max da 1",remarks:"Max Prenotazioni da 1 Coperto"},
              {title:"Max da 2",remarks:"Max Prenotazioni da 2 Coperto"},
              {title:"Max da 3",remarks:"Max Prenotazioni da 3 Coperto"},
              {title:"Durata Pasto",remarks:"Durata Pranzo in Minuti<br>Ovvero entro quanto deve essere lasciato libero il tavolo"},
              /*{title:"Blocca Prec",remarks:"Non accetta prenotazioni su questo slot fino a quando lo slot precedente non ha almeno la percentuale di completezza indicata"},
              {title:"Blocca Succ",remarks:"Non accetta prenotazioni su questo slot fino a quando lo slot successivo non ha almeno la percentuale di completezza indicata"},
              {title:"Cauzione",remarks:"Cauzione richiesta (per ogni coperto) per confermare la prenotazione"},
              {title:"Chiusura DB",remarks:"Non accetta prenotazioni da Direct Booking (per lo stesso giorno) oltre l'ora indicata"},
              {title:"Rich FBack",remarks:"Invia richiesta di feedback su queste prenotazioni"}*/
              ],      
      allMeals:null,
    };
  },
  computed : {
    ...mapGetters(["settings"]),
  },
  beforeUnmount()
  {
      alert("leaving")
  },
  created(){
    this.getData()
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {
    item (newValue) {
      console.log(789,newValue)
      //this.getData(newValue)
    }
  },
  methods:
  {
    checkCapsLock(event,field,value) {
      console.log(365,event,field,value);
      if (event.getModifierState("CapsLock")) {
        this.capsLockOn = true;
        this.activeSlots[field]=value;
      }
      else {
        this.capsLockOn = false;
      }
    },
    async saveItems()
    {
        this.loading_update=true;
        console.log(255,this.form);
        let payload={"action":"saveItem","table":"AllParametersByDOW_Global2","payload":JSON.stringify(this.activeSlots)};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.snackbar = true;
             this.getData();
        }   
    },
    async getData()
    {
        {
            this.loading=true;
            try{
                const payload=JSON.stringify({"date": this.date,"action":"AllParameters_Global2_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                switch (res.data.errorid)
                {
                case '0':
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.loading= false;
                    this.allLocations=res.data.payloads.allLocations;
                    this.allMeals=res.data.payloads.allMeals,
                    this.activeSlots=res.data.payloads.activeSlots;
                    this.activeSlots_hash=JSON.stringify(this.activeSlots);
                    this.tabs=res.data.payloads.allLocations;
                    console.log(282,this.allSlots,this.tabs,this.activeSlots)
                break;
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(324,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success';
            this.snackbar_message=res.data.message;

            if (res.data.message)
            {
                console.log(333);
                //this.snackbar=true;
            }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
            console.log(342);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    }
  },
};
</script>